export const DOCUMENT_EXTRACTION_V2_CONFIDENCE_EXTENSION_URL =
  'http://lifeomic.com/fhir/document-extraction-v2/confidence';
export const DOCUMENT_EXTRACTION_V2_CONFIDENCE_RATIONALE_EXTENSION_URL =
  'http://lifeomic.com/fhir/document-extraction-v2/confidence-rationale';
export const DOCUMENT_EXTRACTION_V2_CONFIDENCE_EVALUATED_AT_EXTENSION_URL =
  'http://lifeomic.com/fhir/document-extraction-v2/confidence-evaluated-at';

export type ExtractionConfidence = {
  value: number;
  rationale?: string;
  evaluatedAt?: string;
};

type ExtractionConfidenceResource = {
  extension?: Array<
    fhir.Extension & {
      valueDecimal?: number | string;
      valueString?: string;
      valueDateTime?: string;
    }
  >;
};

const getExtension = (
  resource: ExtractionConfidenceResource | undefined,
  url: string,
) => resource?.extension?.find(extension => extension.url === url);

export const getExtractionConfidence = (
  resource: ExtractionConfidenceResource | undefined,
): ExtractionConfidence | undefined => {
  const rawValue = getExtension(
    resource,
    DOCUMENT_EXTRACTION_V2_CONFIDENCE_EXTENSION_URL,
  )?.valueDecimal;
  const value =
    typeof rawValue === 'number'
      ? rawValue
      : typeof rawValue === 'string'
      ? Number(rawValue)
      : undefined;

  if (value === undefined || !Number.isFinite(value)) {
    return undefined;
  }

  return {
    value,
    rationale: getExtension(
      resource,
      DOCUMENT_EXTRACTION_V2_CONFIDENCE_RATIONALE_EXTENSION_URL,
    )?.valueString,
    evaluatedAt: getExtension(
      resource,
      DOCUMENT_EXTRACTION_V2_CONFIDENCE_EVALUATED_AT_EXTENSION_URL,
    )?.valueDateTime,
  };
};
